import React, { useContext, forwardRef } from 'react';
import { ModalContext } from '../../context/ModalContext';
import styled from '@emotion/styled';

interface ModalTriggerContainerProps {
  children: React.ReactNode;
  width?: string;
  className?: string;
}

const ModalTriggerContainer = forwardRef<
  HTMLDivElement,
  ModalTriggerContainerProps
>(({ children, width, className }, ref) => {
  const modalContext = useContext(ModalContext);

  const onClick = (e: React.MouseEvent<HTMLDivElement>) => {
    modalContext?.displayModal(true);
  };

  return (
    <Container
      ref={ref}
      onClick={onClick}
      style={{ width: `fit-content ${width}`, cursor: 'pointer' }}
      className={className}
    >
      {children}
    </Container>
  );
});

export default ModalTriggerContainer;

const Container = styled.div`
  &.full {
    width: 100%;
  }

  &.right {
    display: flex;
    align-items: right;
  }
`;
